import { MoreVertIcon } from '@airship-platform/jam-web/icons';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useAuthenticatedUser } from '../../contexts/AuthenticatedUserContext';

const DEFAULT_SIZE = 40;
const DEFAULT_DIMENSIONS = { height: DEFAULT_SIZE, width: DEFAULT_SIZE };

const NavBarFooterProfile: React.FC<{
  onLogoutClick?: () => Promise<unknown>;
}> = ({ onLogoutClick }) => {
  const { user, isLoaded, isLoading, error } = useAuthenticatedUser();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleLogoutClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    const href = e.currentTarget.href;
    if (onLogoutClick) {
      e.preventDefault();
      await onLogoutClick();
      window.location.href = href;
    }
  };

  return (
    <Box>
      {isLoading && !isLoaded && (
        <CircularProgress color="primary" size={DEFAULT_SIZE} />
      )}
      {isLoaded && !user && (
        <Typography variant="body2" color={'error'}>
          {error || 'Unable to load user'}
        </Typography>
      )}
      {user && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 2,
          }}
        >
          {user.profileImage && (
            <Avatar src={user.profileImage} sx={DEFAULT_DIMENSIONS} />
          )}
          <Typography variant="body2" sx={{ flex: 1 }}>
            {user.firstName} {user.lastName}
          </Typography>
          <IconButton
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
            }}
            color="softGold"
            sx={DEFAULT_DIMENSIONS}
          >
            <MoreVertIcon />
          </IconButton>
        </Box>
      )}

      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <MenuItem component={Link} href="/auth/profile">
          View Profile
        </MenuItem>
        <MenuItem
          component={Link}
          href="/auth/signout"
          onClick={handleLogoutClick}
        >
          Sign Out
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default NavBarFooterProfile;
